<template>
  <div ref="box" class="maxwidht">
    <div v-for="(item, index) in defaultImg" :key="index" class="defaultImg">
      <img :src="item" alt="">
    </div>
    <div class="center">{{ currentObj.company_info }}</div>
  </div>
</template>

<script src="../utils/jquery.js"></script>
<script>
import { getPageInfo} from "../utils/api"
import CryptoJS from "crypto-js";
export default {
  name: 'shadows',
  data() {
    return {
      currentObj:{},
      defaultImg: [],
    }
  },
  created() {
    this.getPageDetail()
  },
  mounted(){

  },
  methods: {
    //获取页面详情
    getPageDetail() {
      let codeId=this.getRequestParam()["code_id"]
      let encryptCode = this.encrypt(codeId)
      let param={
        code_id: encryptCode,
        dencrypt_time:this.encrypt((Date.parse(new Date())/1000).toString())
      }
      if (encryptCode) {
        getPageInfo(param).then(res => {
          this.currentObj = res.data
          document.title = this.currentObj.title
          this.defaultImg = this.currentObj.picture_src.split(",")
        }, err => {
        })
      }
    },
    //获取url参数
    getRequestParam(key) {
      var url = window.location.href
      let pattern = /(\w+)=(\w+)/ig; //定义正则表达式
      let parames = {}; // 定义参数对象
      url.replace(pattern, ($, $1, $2) => {
        parames[$1] = $2;
      });
      return parames;
    },
    //加密
    encrypt(text) {
      var key = CryptoJS.enc.Utf8.parse('1463587320654321'); //为了避免补位，直接用16位的秘钥
      var iv = CryptoJS.enc.Utf8.parse('1758326540123456'); //16位初始向量
      var encrypted = CryptoJS.AES.encrypt(text, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
      return encrypted.toString();
    }
  }
}
</script>

<style scoped>
.maxwidht {
  max-width: 500px;
  margin: 0 auto;
}
.defaultImg {
  width: 100%;
  display: flex;
}
.center {
  text-align: center;
}

</style>



// WEBPACK FOOTER //
// src/components/single.vue